import React from 'react'
import {
  Container,
  Row,
  Col
} from 'reactstrap'
import styled from 'styled-components'
import { renderText } from 'utils/text'
import { fontWeight } from 'themes/font'
import Clearfix from 'components/elements/clearfix'
import DownloadMobileApp from 'components/elements/download-mobile-app'

const ConvenientStyled = styled.div`
  background: url('/img/home-page/convenient/bg.svg');
  background-size: cover;
  padding-bottom: 56px;
  .illustration {
    width: 100%;
  }
`

const Text = styled.div`
  display: inline-flex;
  flex-direction: column;
  font-size: 32px;
  font-weight: ${fontWeight.bold};
  color: #333;
  background-image: linear-gradient(transparent 66%, ${props => props.lineColor} 34%);
`

const Convenient = ({ data: { text1, text2, text3 } }) => {
  return (
    <ConvenientStyled>
      <Container>
        <Row className='align-items-center'>
          <Col md={3}>
            <Text lineColor='rgba(0, 200, 255, 0.3)'>{renderText(text1)}</Text>
          </Col>
          <Col md={6}>
            <img src='/img/home-page/convenient/illustration.png' className='illustration' alt='illustration' />
          </Col>
          <Col md={3}>
            <Text lineColor='rgba(79, 92, 121, 0.2)'>{text2}</Text>
            <Clearfix height={32} />
            <Text lineColor='rgba(255, 178, 88, 0.5)'>{text3}</Text>
            <Clearfix height={32} />
            <DownloadMobileApp direction='column' />
          </Col>
        </Row>
      </Container>
    </ConvenientStyled>
  )
}

export default Convenient
